import { useQuery } from '@tanstack/react-query';
import { getBalance, getRampRequest } from '@/api/adapter/finance';
import { useAuthStore } from '@/stores/authStore';

export function useBalance() {
  const principal = useAuthStore((state) => state.session?.principalId);
  return useQuery({
    queryKey: ['current-finance', principal, 'balance'],
    enabled: !!principal,
    retry: false,
    staleTime: 10000,
    queryFn: async ({ signal }) => {
      const value = await getBalance(signal);
      if (useAuthStore.getState().session?.principalId !== principal)
        throw new Error('Your account changed. Reload the balance.');
      return value;
    },
  });
}
export function useRampRequest(kind: 'deposit' | 'withdrawal', id: string) {
  const principal = useAuthStore((state) => state.session?.principalId);
  return useQuery({
    queryKey: ['current-finance', principal, kind, id],
    enabled: !!principal && !!id,
    retry: false,
    staleTime: 10000,
    queryFn: async ({ signal }) => {
      const value = await getRampRequest(kind, id, signal);
      if (useAuthStore.getState().session?.principalId !== principal)
        throw new Error('Your account changed. Reload the request.');
      return value;
    },
  });
}
